import React from 'react';
import cn from 'classnames';
import './Input.scss';

interface Props {
  inputType: string;
  width: string;
  onChange(e: React.ChangeEvent<HTMLInputElement>): void;
  label?: string;
  placeHolder?: string;
  value?: string;
  checked?: boolean;
  disabled?: boolean
  inputRef?: React.MutableRefObject<any>
  onKeyUpHandler?: (e: React.KeyboardEvent<HTMLInputElement>) => void
  warning?: boolean
  minValue?: number | string | undefined
  maxValue?: number | string | undefined
  displayStyle?: string | undefined
  height?: number | undefined
  defaultValue?: string | undefined
  handleBlur?: (e: React.FocusEvent<HTMLInputElement, Element>) => void
  id?: string
}

const Input: React.FC<Props> = ({
  inputType,
  width,
  onChange,
  id = undefined,
  label = undefined,
  placeHolder = undefined,
  value = '',
  inputRef = null,
  onKeyUpHandler,
  disabled = false,
  warning = false,
  minValue = undefined,
  maxValue = undefined,
  checked = undefined,
  displayStyle = undefined,
  height = undefined,
  defaultValue = undefined,
  handleBlur,
}) => {
  return (
    <div
      className="textInputBlock"
      style={
        {
          display: displayStyle || 'flex',
        }
      }
    >
      {label && (
        <label
          htmlFor={label}
          style={{ color: warning ? '#dc3545' : '' }}
        >
          {label}
        </label>)}
      <input
        value={value}
        checked={checked}
        placeholder={placeHolder}
        onBlur={(e) => handleBlur && handleBlur(e)}
        id={id ?? label}
        type={`${inputType}`}
        min={minValue}
        max={maxValue}
        style={{ width: `${width}`, height: `${height}px` }}
        className={cn('textInputBlock__Input', {
          'textInputBlockWarning': warning,
        })}
        onChange={(e) => onChange!(e)}
        ref={inputRef}
        onKeyUp={onKeyUpHandler && onKeyUpHandler!}
        autoCapitalize="off"
        autoComplete="off"
        disabled={disabled}
        defaultValue={defaultValue}
      />
    </div>
  );
};

export default Input;
